import { Link } from "react-router-dom";
import { categories } from "@/mocks/anime";

const quickLinks = [
  { to: "/", label: "首页" },
  { to: "/about", label: "关于我们" },
];

export default function Footer() {
  return (
    <footer className="bg-secondary-900 text-secondary-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div className="lg:col-span-1">
            <div className="flex items-center gap-2">
              <span className="w-9 h-9 rounded-full bg-secondary-700 text-white flex items-center justify-center text-lg">
                <i className="ri-sparkling-2-fill"></i>
              </span>
              <span className="font-heading text-xl text-white">妖精动漫网</span>
            </div>
            <p className="mt-4 text-sm text-secondary-300 leading-relaxed">
              一个专注妖精、精灵、妖怪题材的奇幻番剧聚合站。集中整理相关作品，按题材轻松查找，追更入口清晰。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-white tracking-wide">题材栏目</h4>
            <ul className="mt-4 space-y-3">
              {categories.map((c) => (
                <li key={c.type}>
                  <Link
                    to={`/category/${c.type}`}
                    className="text-sm text-secondary-300 hover:text-white inline-flex items-center gap-2"
                  >
                    <i className={c.icon}></i>
                    {c.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-white tracking-wide">快捷导航</h4>
            <ul className="mt-4 space-y-3">
              {quickLinks.map((l) => (
                <li key={l.to}>
                  <Link to={l.to} className="text-sm text-secondary-300 hover:text-white">
                    {l.label}
                  </Link>
                </li>
              ))}
              <li>
                <Link to="/about" className="text-sm text-secondary-300 hover:text-white">
                  版权与投稿
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-white tracking-wide">温馨提示</h4>
            <p className="mt-4 text-sm text-secondary-300 leading-relaxed">
              本站为奇幻番剧题材整理与推荐聚合站，播放以各正版平台实际上线为准。如对收录内容有疑问，欢迎联系我们反馈。
            </p>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-secondary-700 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-secondary-400">
            © 2026 妖精动漫网 · 专注于妖精 / 精灵 / 妖怪题材的奇幻番剧聚合
          </p>
          <p className="text-xs text-secondary-400">本网站内容仅供题材整理与推荐</p>
        </div>
      </div>
    </footer>
  );
}